export enum ExportToType {
	CSV = 'csv',
	XLSX = 'xlsx',
	JSON = 'json',
}

export type CsvToOptions = {
	fileName: string;
	delimiter?: string; // default: ','
	keysAndTitles?: {key: string; title: string}[];
};

export type ExcelOptions = {
	fileName: string;
	sheetName?: string;
	type?: 'base64' | 'buffer' | 'binary' | 'file' | 'array' | 'string'; // Optional: Output data encoding
	keysAndTitles?: {key: string; title: string}[];
};
